(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-shoe-thumbs]').forEach((nav) => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const root = nav.closest('[data-mp-product]');
      const track = root.querySelector('[data-mp-gallery-track]');
      const thumbs = [...nav.querySelectorAll('[data-shoe-media]')];
      const slides = [...track.querySelectorAll('[data-media-id]')];
      const visible = () => slides.filter((slide) => !slide.hidden);
      const select = (slide) => thumbs.forEach((thumb) => {
        if (thumb.dataset.shoeMedia === slide?.dataset.mediaId) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      const sync = () => {
        const current = visible();
        thumbs.forEach((thumb) => {
          thumb.hidden = !current.some((slide) => slide.dataset.mediaId === thumb.dataset.shoeMedia);
        });
        if (!current.some((slide) => thumbs.some((thumb) => thumb.hasAttribute('aria-current') && thumb.dataset.shoeMedia === slide.dataset.mediaId))) select(current[0]);
      };
      nav.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-shoe-media]');
        if (!thumb) return;
        const slide = slides.find((item) => item.dataset.mediaId === thumb.dataset.shoeMedia);
        if (!slide || slide.hidden) return;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        if (matchMedia('(min-width: 990px)').matches) slide.scrollIntoView({block:'center',behavior});
        else track.scrollTo({left:visible().indexOf(slide) * track.clientWidth,behavior});
        select(slide);
      });
      let frame = 0;
      track.addEventListener('scroll', () => {
        if (frame || matchMedia('(min-width: 990px)').matches) return;
        frame = requestAnimationFrame(() => { frame = 0; select(visible()[Math.round(track.scrollLeft / Math.max(1,track.clientWidth))]); });
      }, {passive:true});
      new MutationObserver(sync).observe(track,{subtree:true,attributes:true,attributeFilter:['hidden']});
      sync();
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',(event)=>init(event.target));
})();
